import { useEffect, useState } from "react";
import { db } from "@/services/firebaseService";
import { getDecimalEnums } from "@/services/decimalEnumService";

export interface GradeOption {
  value: string;
  label: string;
}

export const useGradeOptions = () => {
  const [gradeOptions, setGradeOptions] = useState<GradeOption[]>([{ value: "none", label: "None" }]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadGradeOptions = async () => {
      try {
        const gradeEnum = await getDecimalEnums(db, "grade");
        const filtered = gradeEnum.filter((item: any) => item.id !== "g_all" && item.id !== "g_unknown" && item.id !== "g_na");
        const sorted = filtered.sort((a: any, b: any) => a.value - b.value);
        const options: GradeOption[] = [
          { value: "none", label: "None" },
          ...sorted.map((item: any) => ({ value: item.id, label: item.longLabel || item.id }))
        ];
        setGradeOptions(options);
      } catch (e) {
        console.error("Error loading grade options:", e);
      } finally {
        setLoading(false);
      }
    };

    loadGradeOptions();
  }, []);

  return { gradeOptions, loading };
};


